import React, { useEffect, useState } from "react";
import "./Hero.css";

/*
=========================================================
STRIDES ENERGY & MARITIME
HERO SECTION / CAROUSEL

The images and text are separate layers.

Images are stored in:

public/images/

Current images:
1. marine (1).webp
2. iprs.webp

Slides 3 and 4 are prepared but commented out
until their images are available.
=========================================================
*/

/*
=========================================================
SLIDE DATA
=========================================================
*/

const slides = [
  /*
  ---------------------------------------------------------
  SLIDE 1
  ---------------------------------------------------------
  */

  {
    image: "/images/marine (1).webp",
    eyebrow: "ENERGY & MARITIME",
    title: "Powering Progress.",
    description:
      "Delivering reliable energy, maritime and engineering solutions through expertise, innovation and operational excellence.",
  },


  /*
  ---------------------------------------------------------
  SLIDE 2
  ---------------------------------------------------------
  */

  {
    image: "/images/iprs.webp",
    eyebrow: "INTEGRATED PIPELINE REPAIR SERVICES",
    title: "Restoring Pipeline Performance.",
    description:
      "Our integrated pipeline repair solutions help protect critical infrastructure, reduce downtime and keep energy operations safe, reliable and moving forward.",
  },


  /*
  ---------------------------------------------------------
  SLIDE 3
  ---------------------------------------------------------

  Uncomment when the third image is available.

  Example:
  image: "/images/third-image.webp"
  ---------------------------------------------------------
  */

  
  {
    image: "/images/ceo2.webp",
    eyebrow: "CEO VISION & LEADERSHIP",
    title: "Leadership That Moves the Industry Forward.",
    description:
      "Guided by strategic leadership, operational discipline and a commitment to excellence, our CEO drives innovation, accountability and long-term value across every mission.",
  },
  


  /*
  ---------------------------------------------------------
  SLIDE 4
  ---------------------------------------------------------

  Community impact and service-focused leadership.
  ---------------------------------------------------------
  */

  {
    image: "/images/community.webp",
    eyebrow: "COMMUNITY IMPACT & SERVICE",
    title: "Building Stronger Communities Through Service.",
    description:
      "We believe progress is measured not only in operations, but in the lives we uplift through responsible service, partnership and community care.",
  },


  /*
  ---------------------------------------------------------
  SLIDE 5
  ---------------------------------------------------------

  Petroleum tank construction and rehabilitation services.
  ---------------------------------------------------------
  */

  {
    image: "/images/tank2.webp",
    eyebrow: "PETROLEUM TANK CONSTRUCTION",
    title: "Built for Safe, Reliable Storage.",
    description:
      "From new petroleum tank construction to rehabilitation, we deliver carefully planned storage solutions built for safety, durability and dependable operations.",
  },
];


function Hero() {

  /*
  =========================================================
  CURRENT SLIDE
  =========================================================
  */

  const [currentSlide, setCurrentSlide] = useState(3);


  /*
  =========================================================
  AUTOMATIC CAROUSEL

  Changes slide every 6 seconds.
  =========================================================
  */

  useEffect(() => {
    const interval = setInterval(() => {

      setCurrentSlide((previousSlide) => {

        if (previousSlide === slides.length - 1) {
          return 0;
        }

        return previousSlide + 1;
      });

    }, 6000);


    /*
    -------------------------------------------------------
    CLEAN UP TIMER
    -------------------------------------------------------
    */

    return () => clearInterval(interval);

  }, []);


  /*
  =========================================================
  MANUAL SLIDE SELECTION
  =========================================================
  */

  const goToSlide = (index) => {

    setCurrentSlide(index);

  };


  /*
  =========================================================
  HERO
  =========================================================
  */

  return (
    <>
      <section
        className="hero"
        aria-label="Strides Energy & Maritime"
      >

      {/* =================================================
          SLIDES
          ================================================= */}

      <div className="hero-slides">

        {slides.map((slide, index) => (

          <article
            className={`hero-slide ${
              index === currentSlide ? "active" : ""
            }`}
            key={slide.image}
          >

            {/* =============================================
                IMAGE LAYER
                ============================================= */}

            <div className="hero-image">

              <img
                src={slide.image}
                alt={slide.title}
              />

            </div>


            {/* =============================================
                IMAGE OVERLAY

                This is separate from both image and text.
                ============================================= */}

            <div className="hero-overlay"></div>


            {/* =============================================
                TEXT LAYER

                The text is completely independent
                from the image.
                ============================================= */}

            <div className="hero-content">

              {/* -----------------------------------------
                  EYEBROW
                  ----------------------------------------- */}

              <span className="hero-eyebrow">
                {slide.eyebrow}
              </span>


              {/* -----------------------------------------
                  MAIN HEADING
                  ----------------------------------------- */}

              <h1>
                {slide.title}
              </h1>


              {/* -----------------------------------------
                  DESCRIPTION
                  ----------------------------------------- */}

              <p>
                {slide.description}
              </p>


            </div>

          </article>

        ))}

      </div>


      {/* =================================================
          CAROUSEL INDICATORS
          ================================================= */}

      <div
        className="hero-carousel-dots"
        aria-label="Hero carousel controls"
      >

        {slides.map((slide, index) => (

          <button
            key={slide.image}
            type="button"
            className={`hero-carousel-dot ${
              index === currentSlide ? "active" : ""
            }`}
            onClick={() => goToSlide(index)}
            aria-label={`Show slide ${index + 1}`}
            aria-current={
              index === currentSlide
                ? "true"
                : undefined
            }
          />

        ))}

      </div>

      </section>

    </>
  );
}


export default Hero;